/** Server actions for the per-site Google Workspace panel. Each takes the hook context `c`
 *  ({ site, reload, form, setField, run, setMsg, setStatus, setMatrix, setErr }). */
import { api } from "@/lib/api";

const wroteCount = (writes) => (writes || []).filter((w) => w.action === "created" || w.action === "updated").length;

export async function connect(c) {
  const body = { mode: c.form.mode, inbound: c.form.inbound, mail_cname: c.form.mailCname };
  if (c.form.dkim.trim()) body.dkim_value = c.form.dkim.trim();
  const r = await c.run("connect", () => api.post(`/sites/${c.site.id}/gws/connect`, body), { reloadSite: true });
  if (!r) return;
  c.setMsg(`Added to Workspace as ${c.form.mode} · ${wroteCount(r.data.dns_writes)} DNS record(s) written · ${r.data.verified ? "verified ✓" : "verification pending (DNS propagating)"}`);
  c.setField("dkim", "");
}

export async function fixDns(c) {
  const r = await c.run("fix", () => api.post(`/sites/${c.site.id}/gws/dns/apply`));
  if (r) c.setMsg(`Fix DNS · wrote ${wroteCount(r.data.writes)}, skipped ${(r.data.writes || []).length - wroteCount(r.data.writes)}`);
}

export async function verifyNow(c) {
  const r = await c.run("verify", () => api.post(`/sites/${c.site.id}/gws/verify`));
  if (!r) return;
  c.setMsg(r.data.verified ? "Google confirmed domain ownership ✓" : `Not verified yet — ${r.data.error || "DNS still propagating"}`);
  if (r.data.verified) await c.reload();
}

export async function saveDkim(c) {
  if (!c.form.dkim.trim()) { c.setErr("Paste the DKIM TXT value first"); return; }
  const r = await c.run("dkim", () => api.patch(`/sites/${c.site.id}/gws`, { dkim_value: c.form.dkim.trim() }), { reloadSite: true });
  if (!r) return;
  c.setMsg("DKIM saved and written to Cloudflare — now click “Start authentication” in the Admin console");
  c.setField("dkim", "");
}

export async function changeInbound(c, value) {
  const r = await c.run("inbound", () => api.patch(`/sites/${c.site.id}/gws`, { inbound: value }), { reloadSite: true });
  if (r) c.setMsg(value === "workspace" ? "Google MX written — Gmail now receives mail for this domain" : "Inbound mode set to sending-only (existing MX untouched)");
}

export async function disconnect(c) {
  const removeGoogle = window.confirm("Also REMOVE the domain from Google Workspace? (OK = remove from Google too, Cancel = keep it there)");
  if (!window.confirm(`Disconnect Google Workspace from ${c.site.domain} and delete the verification / DKIM / Google MX / mail CNAME records?${removeGoogle ? " The domain will also be removed from the Workspace." : ""}`)) return;
  const r = await c.run("disconnect", () => api.delete(`/sites/${c.site.id}/gws/disconnect?delete_dns=true&remove_from_google=${removeGoogle}`), { reloadSite: true });
  if (!r) return;
  c.setMsg(`Disconnected · ${(r.data.dns_deleted || []).length} DNS record(s) removed${r.data.google_error ? ` · Google: ${r.data.google_error}` : ""}`);
  c.setStatus(null); c.setMatrix([]);
}
